import angular from 'angular';
import moment from 'moment';
export default class OperatorsAPIService {
  constructor($http, appSettings) {
    'ngInject';
    this.$http = $http;
    this.appSettings = appSettings;
    this.baseEndpointUrl = `${this.appSettings.InReachApiEndpoint}access/operators`;
  }

  operatorsCsvToJson(csvFile) {
    const endPointUrl = `${this.baseEndpointUrl}/upload_csv`;
    const data = new FormData();
    data.append('csv-file', csvFile);
    return this.$http.post(endPointUrl, data, {
      transformRequest: angular.identity,
      headers: { 'Content-Type': undefined },
    });
  }

  bulkCreateOperators(operatorsList) {
    const endPointUrl = `${this.baseEndpointUrl}/bulk/create`;
    return this.$http.post(endPointUrl, operatorsList);
  }

  getOperators() {
    const endPointUrl = `${this.baseEndpointUrl}`;
    return this.$http.get(endPointUrl);
  }

  getOperatorById(id) {
    const endPointUrl = `${this.baseEndpointUrl}/${id}`;
    return this.$http.get(endPointUrl);
  }

  updateOperatorsCodes(operatorId, codes, autoGeneratePin) {
    const endPointUrl = `${this.baseEndpointUrl}/${operatorId}/codes`;
    return this.$http.put(endPointUrl, { autoGeneratePin, accessCodes: codes });
  }

  updateOperatorMetaData(operatorId, name, attrs) {
    if (attrs.expiry) {
      attrs.expiry = moment(attrs.expiry).utc(true).format('L');
    }

    const endPointUrl = `${this.baseEndpointUrl}/${operatorId}`;
    return this.$http.put(endPointUrl, { id: operatorId, name, attrs });
  }

  createOperater(operator) {
    const endPointUrl = `${this.baseEndpointUrl}`;
    return this.$http.post(endPointUrl, {
      name: operator.name,
      attrs: operator.attrs,
      accessCodes: operator.accessCodes,
      autoGeneratePIN: operator.autoGeneratePIN,
    });
  }

  deleteOperater(operatorId) {
    const endPointUrl = `${this.baseEndpointUrl}/${operatorId}?force=true`;
    return this.$http.delete(endPointUrl);
  }

  getOperatorExpiryById(id) {
    const endPointUrl = `${this.baseEndpointUrl}/expiry/${id}`;
    return this.$http.get(endPointUrl);
  }
}
